import React, { useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';
import { animation } from '@naf/theme';
import { propValidationConfig } from "./propValidationConfig";
export const AnimateStatic = ({
  children,
  delay,
  timeout = animation.brandSpeed,
  className
}) => {
  const [inProp, setInProp] = React.useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (delay) {
      setTimeout(() => {
        setInProp(true);
      }, delay);
    } else {
      setInProp(true);
    }
  }, [delay]);
  return /*#__PURE__*/React.createElement(HideOverflow, null, /*#__PURE__*/React.createElement(CSSTransition, {
    nodeRef: ref,
    timeout: timeout,
    in: inProp,
    classNames: "node"
  }, /*#__PURE__*/React.createElement(Animated, {
    ref: ref,
    timeout: timeout,
    className: className
  }, children)));
};
const Animated = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "AnimateStatic__Animated",
  componentId: "sc-d0cw84-0"
})(["transform:translateX(-100%);&.node-enter-active,&.node-enter-done{transform:translateX(0);transition:", "ms ", ";}"], ({
  timeout
}) => timeout, animation.easeIn);
const HideOverflow = styled.div.withConfig({
  displayName: "AnimateStatic__HideOverflow",
  componentId: "sc-d0cw84-1"
})(["overflow:hidden;"]);
//# sourceMappingURL=AnimateStatic.js.map